<template>
  <v-main>
    <TheHeader/>
    <TheNavigation/>
    <TheBreadcrumbs v-if="!$route.name.includes('404') && !$route.name.includes('403')"/>
    <v-layout>
      <slot/>
    </v-layout>
  </v-main>
</template>

<script>

import TheHeader from '@/components/TheHeader.vue';
import TheNavigation from '@/components/TheNavigation.vue';
import TheBreadcrumbs from '@/components/TheBreadcrumbs.vue';

export default {
  name: 'MainLayout',
  components: { TheBreadcrumbs, TheNavigation, TheHeader },
};
</script>
